import type { MlRecommendationTracking } from '@/types/tracking/ml-recommendation';
import { SNOWPLOW_CONTEXT_MAPPING, type SnowplowContextInput } from '@/tracking/snowplow/utils';

export const getMlRecommendationContexts = (tracking: MlRecommendationTracking | null): SnowplowContextInput[] => {
    if (!tracking) {
        return [];
    }

    return [
        {
            contextType: SNOWPLOW_CONTEXT_MAPPING.ML_RECOMMENDATION,
            contextProps: { ...tracking.recommendation }
        },
        ...tracking.items.map((item) => ({
            contextType: SNOWPLOW_CONTEXT_MAPPING.ML_RECOMMENDATION_ITEM,
            contextProps: { ...item }
        }))
    ];
};
